import React from 'react';
import Layout from "../../components/Layout";

const NoMatch = () => {
    return (
        <Layout>
            <h1>Sorry, page not found(</h1>
        </Layout>
    );
};

export default NoMatch;